<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P00043.control.bottomMenu.mode' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    <app-mode-control-multiple
      [datas]="[
        {
          ref: 0,
          label: 'P00043.control.modeFonctionnement.off' | translate,
          icon: 'fa-kit fa-picto-off',
          color: 'color-red',
        },
        {
          ref: 1,
          label: 'P00043.control.modeFonctionnement.horl' | translate,
          icon: 'fa-kit fa-picto-horloge',
          color: 'color-orange',
        },
        {
          ref: 2,
          label: 'P00043.control.modeFonctionnement.regul' | translate,
          icon: 'fa-kit fa-picto-horloge',
          color: 'color-programme',
        },
        {
          ref: 3,
          label: 'P00043.control.modeFonctionnement.on' | translate,
          icon: 'fa-kit fa-picto-on',
          color: 'color-green',
        },
      ]"
      [value]="this.actionStack!.getValue('paCModeFonctionnement')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PAC_Control,
          'paCModeFonctionnement',
          $event
        );
        this.actionStack!.commit()
      "
    >
    </app-mode-control-multiple>
  </div>
</div>

@if (this.actionStack!.getValue('paCModeFonctionnement') === 2) {
  <div class="my-2 mb-4">
    <div class="row">
      <div class="col">
        <ion-label class="color-medium text-uppercase">{{
          'P00043.installation.regulation.consigne.value' | translate
        }}</ion-label>
      </div>
    </div>
    <div class="my-3">
      <div
        class="mode-control overflow-hidden temperature-slider"
        (click)="onClick($event)"
        (mousedown)="onMouseDown($event)"
        (mousemove)="onMouseMove($event)"
        (mouseup)="onMouseUp($event)"
        (mouseleave)="onMouseUp($event)"
        (touchstart)="onTouchStart($event)"
        (touchmove)="onTouchMove($event)"
        (touchend)="onTouchEnd($event)"
      >
        <!-- Barre de progression -->
        <div
          class="position-absolute temperature-fill"
          [style.width.%]="getTempPercentage()"
          style="top: 0; bottom: 0; left: 0; transition: width 0.1s ease-out"
        ></div>

        <!-- Indicateur de température -->
        <div
          class="position-absolute"
          style="top: 0; bottom: 0; left: 0; right: 0; pointer-events: none"
        >
          <div class="row h-100 align-items-center">
            <div class="col fs-26">
              <div class="px-3">
                <i class="fa-kit fa-picto-teau"></i>
              </div>
            </div>
            <div class="col-auto fs-20">
              <div class="px-3">
                {{ getDisplayTemp() }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
